/**
 * Avoid globals while we migrate old implementations
 */
export var globalStyles = {
    global: {},
};
